<mat-form-field class="full-width" appearance="{{appearance}}">
  <mat-label>{{label}}</mat-label>
  <input matInput type="text" readonly [placeholder]="placeholder" [value]="imgDescription">
  <button fxFlex="60px" color="accent" mat-raised-button type="button" (click)="browseFile()" [disabled]="disabled">
    <mat-icon>{{icon}}</mat-icon>
  </button>
  <input #fileInput type="file" hidden (change)="handleFileInput($event.target.files)">
</mat-form-field>